export default __webpack_public_path__ + "static/media/AR.da11ca66.svg";